import { html, View } from 'rune-ts';
import { typo } from '../../../../../services/MarppleShop/shared/typography/typo';
import klass from './MembershipSettingForm.module.scss';
import { MultiSelectButtonGroup } from '../../../../../services/MarppleShop/renderApp/components/cells/MultiSelectButtonGroup/MultiSelectButtonGroup';
import { map, pipe, toArray } from '@fxts/core';
import {
  MEMBERSHIP_STATE,
  PartialMembership,
} from '../../../../../services/MarppleShop/features/Membership/type';
import { tooltipIcon2El } from '../../../../Util/S/Tmpl/tootip';
import { UtilS } from '../../../../Util/S/Function/module/UtilS';
import { initTooltips2 } from '../../../../Util/F/tooltip';

interface Membership {
  id: string;
  name: string;
}

export interface MembershipSettingSectionData {
  memberships: (PartialMembership & { selected: boolean })[];
}

interface MembershipSettingSectionOption {
  klass?: string;
}

export class MembershipSettingSection extends View<Readonly<MembershipSettingSectionData>> {
  private readonly MultiSelectButtonGroupView: MultiSelectButtonGroup;

  constructor(
    data: Readonly<MembershipSettingSectionData>,
    private option: MembershipSettingSectionOption = {},
  ) {
    super(data, option);

    const datas = pipe(
      this.data.memberships,
      map((membership) => ({
        ...membership,
        name: this.makeMembershipDisplayName(membership),
      })),
      toArray,
    );
    this.MultiSelectButtonGroupView = new MultiSelectButtonGroup(datas);
  }

  override onRender() {
    initTooltips2({
      container_el: this.element(),
    });
  }

  override template() {
    const localized_text = this.getLocalizedText();

    if (!this.isSectionVisible()) {
      return html`<section></section>`;
    }

    return html`<section class="${klass.membership_setting_section} ${this.option.klass ?? ''}">
      <div class="${klass.title_container}">
        <span class="${typo('14_bold')}">${localized_text.title}</span>
        <span class="tooltip-icon2 tooltip-icon2--question">${tooltipIcon2El(html)}</span>
        <div class="tooltip-container">
          <div class="editor-tooltip-box">
            ${html.preventEscape(UtilS.escape(localized_text.tooltip_content, true))}
          </div>
        </div>
      </div>
      ${this.MultiSelectButtonGroupView}
    </section>`;
  }

  private getLocalizedText() {
    return {
      title: ET('mps2::seller_studio::membership_setting::title'),
      tooltip_content: ET('mps2::seller_studio::membership_setting::tooltip_content'),
      private: ET('mps2::seller_studio::membership_setting::private'),
    };
  }

  private isSectionVisible(): boolean {
    return this.data.memberships.length > 0;
  }

  private makeMembershipDisplayName({
    state,
    displayName,
  }: Pick<PartialMembership, 'state' | 'displayName'>) {
    if (state === MEMBERSHIP_STATE.HIDDEN) {
      return `${displayName} (${this.getLocalizedText().private})`;
    } else {
      return displayName;
    }
  }

  getSelectedMembershipIds(): Membership['id'][] {
    return this.MultiSelectButtonGroupView.getSelectedIds();
  }

  hasChanged(): boolean {
    return this.MultiSelectButtonGroupView.hasChanged();
  }
}
